export default __webpack_public_path__ + "static/media/Conscript's Chestplate of Heaven's Pass.7a575e42.jpg";